import { Search } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalSearch } from './GlobalSearchProvider';

const isMacPlatform = () =>
    typeof navigator !== 'undefined' && /mac|iphone|ipad/i.test(navigator.userAgent);

/** The top-bar entry to the global search, showing its keyboard shortcut. */
const GlobalSearchTrigger = () => {
    const { t } = useTranslation();
    const { open } = useGlobalSearch();
    const shortcut = isMacPlatform() ? '⌘K' : 'Ctrl+K';

    return (
        <button
            type={'button'}
            onClick={open}
            title={t('global_search.open')}
            aria-label={t('global_search.open')}
            aria-keyshortcuts={'Meta+K Control+K'}
            className={
                'flex items-center gap-2 mr-2 p-2 lg:px-3 lg:py-1.5 rounded-full lg:rounded-[5px] text-sm text-foreground/60 ' +
                'lg:border lg:border-foreground/10 hover:text-foreground hover:bg-foreground/5'
            }
        >
            <Search className={'w-5 h-5 lg:w-4 lg:h-4'} />
            <span className={'hidden lg:inline'}>{t('global_search.trigger')}</span>
            <kbd className={'hidden lg:inline ml-4 text-xs font-sans text-foreground/50'}>{shortcut}</kbd>
        </button>
    );
};

export default GlobalSearchTrigger;
